import { useEffect, useState } from 'react';
import Professional from './Professional';

function Professionals({ clinic, booking, specialty, setFieldValue, t }) {
    const [filteredProfessionals, setFilteredProfessionals] = useState([]);

    useEffect(() => {
        setFilteredProfessionals(specialty ? clinic.professionals.filter(({ specialties }) => specialties.some(({ id }) => id == specialty)) : clinic.professionals);
    }, [clinic, specialty]);

    return (
        <div className="grid items-start grid-cols-1 gap-4 md:grid-cols-2">
            {filteredProfessionals.length ? (
                filteredProfessionals.map((professional) => <Professional key={professional.id} {...professional} booking={booking} setFieldValue={setFieldValue} />)
            ) : (
                <div>{t('no-professionals')}</div>
            )}
        </div>
    );
}

export default Professionals;
